<button
  [disabled]="isSyncButtonDisabled(connectionStatusService.networkStatus$ | async)"
  mat-icon-button
  [matTooltip]="'TASKS.SYNC_TASK' | translate"
  (click)="synchronizeTask($event)">
  <mat-icon>sync</mat-icon>
</button>
<button
  [disabled]="!cellValue.isValid || !(connectionStatusService.networkStatus$ | async) || cellValue.status !== 'IN_PROGRESS'"
  mat-icon-button
  [matTooltip]="'TASKS.COPY' | translate"
  (click)="copyTask($event)">
  <mat-icon>content_copy</mat-icon>
</button>
<button
  *ngIf="store.isAdmin() && (connectionStatusService.networkStatus$ | async) && (cellValue.status === 'IN_PROGRESS' || cellValue.status === 'DRAFT') && (params.context['tasksListMode'] === 'ACTIVE')"
  mat-icon-button
  (click)="assignToUser($event)"
  [matTooltip]="'TASKS.SET_ASSIGNEE' | translate"
>
  <icon-outline icon="person_add_alt"></icon-outline>
</button>
<button
  *ngIf="(connectionStatusService.networkStatus$ | async) && params.context['tasksListMode'] === 'ARCHIVED' && cellValue.order.source === 'PSE'"
  mat-icon-button
  (click)="refreshPseStatus($event)"
  [matTooltip]="'TASKS.REFRESH_PSE_STATUS' | translate"
>
  <mat-icon>refresh</mat-icon>
</button>
